/**
 * 定时器
 * @param {number} interval 时间，毫秒
 */
export default function sleep(interval) {
    return new Promise(function (resolve) {
        setTimeout(resolve, interval);
    });
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/utils/sleep.js
// module id = null
// module chunks = 